import React from "react";
var Loader = require("react-loaders").Loader;

var PageLoader = () => {
  return (
    <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
  );
};

export default PageLoader;
